<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">
        {{ $t('inventory.operation.stock_count_entry.actual_count_entry') }}
      </h1>
      <ts-breadcrumb
        :items="[
          { text: $t('toHomePage'), href: '/' },
          {
            text: $t(
              'inventory.operation.stock_count_entry.actual_count_entry'
            ),
            href: '/stock-count_entrys'
          },
          {
            text: $t('edit'),
            active: true
          }
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <form class="form-horizontal">
          <div class="row mb-3">
            <div class="col-sm-12 col-lg-6 col-md-12">
              <div class="form-group row">
                <label class="col-md-4 form-col-label control-label required">
                  {{ $t('inventory.operation.stock_count_entry.date') }}
                </label>
                <div class="col-md-7">
                  <ts-date-picker-input
                    v-model="model.count_date"
                    disabled
                  ></ts-date-picker-input>
                  <div class="validate" v-if="errors.has('count_date')">
                    {{ errors.first('count_date') }}
                  </div>
                </div>
              </div>
              <div class="form-group row">
                <label class="col-md-4 form-col-label control-label required">
                  {{ $t('inventory.operation.stock_count_entry.note') }}
                </label>
                <div class="col-md-7">
                  <textarea
                    v-model="model.note"
                    rows="3"
                    class="form-control"
                    :class="{ 'is-invalid': errors.has('note') }"
                  ></textarea>
                  <div class="invalid-feedback" v-if="errors.has('note')">
                    {{ errors.first('note') }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
        <form>
          <div class="row">
            <div class="col-md-12">
              <div id="container-table">
                <table class="table ui-table table-hover">
                  <thead>
                    <tr>
                      <th style="width:14%">
                        {{
                          $t('inventory.operation.stock_count_entry.barcode')
                        }}
                      </th>
                      <th style="width:18%">
                        {{
                          $t('inventory.operation.stock_count_entry.product')
                        }}
                      </th>
                      <th class="text-center" style="width:9%">
                        {{
                          $t('inventory.operation.stock_count_entry.system_qty')
                        }}
                      </th>
                      <th style="width:9%">
                        {{
                          $t('inventory.operation.stock_count_entry.count_qty')
                        }}
                      </th>
                      <th style="width:9%">
                        {{
                          $t(
                            'inventory.operation.stock_count_entry.difference_quantity'
                          )
                        }}
                      </th>
                      <th style="width:15%">
                        {{ $t('inventory.operation.stock_count_entry.reason') }}
                      </th>
                      <th style="width: 2%" class="text-center">
                        <a href="#" class="text-primary">
                          <i class="fas fa-spinner spin" v-if="ready_fetch"></i>
                          <i
                            class="fa fa-plus"
                            v-else
                            @click.prevent="addNewRow"
                          ></i>
                        </a>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, index) in model.details" :key="index">
                      <td>
                        <ts-search-select
                          v-model="item.barcode"
                          :options="
                            productNotIncludeSelected({
                              addedProducts: model.details,
                              excludeProductId: item.product_id
                            }).map(el => ({
                              value: el.barcode,
                              text: el.barcode
                            }))
                          "
                          :filterFunction="filterProductFunction"
                          @change="barcodeChange(item)"
                        ></ts-search-select>
                      </td>
                      <td>
                        <ts-search-select
                          v-model="item.product_id"
                          :options="
                            productNotIncludeSelected({
                              addedProducts: model.details,
                              excludeProductId: item.product_id
                            }).map(el => ({
                              value: el.product_id,
                              text: el.product_name_en
                            }))
                          "
                          :filterFunction="filterProductFunction"
                          @change="productChange(item)"
                        ></ts-search-select>
                        <div
                          class="validate"
                          v-if="errors.has('details.' + index + '.product_id')"
                        >
                          {{ errors.first('details.' + index + '.product_id') }}
                        </div>
                      </td>
                      <td>
                        <input
                          type="number"
                          v-model.number="item.system_qty"
                          class="form-control only-border-bottom"
                          readonly
                        />
                      </td>
                      <td>
                        <input
                          type="number"
                          v-model.number="item.count_qty"
                          class="form-control only-border-bottom"
                          :class="{
                            'is-invalid': errors.has(
                              'details.' + index + '.count_qty'
                            )
                          }"
                        />
                        <div
                          class="invalid-feedback"
                          v-if="errors.has('details.' + index + '.count_qty')"
                        >
                          {{ errors.first('details.' + index + '.count_qty') }}
                        </div>
                      </td>
                      <td>
                        <input
                          type="number"
                          v-model.number="item.different_qty"
                          class="form-control only-border-bottom"
                          readonly
                        />
                      </td>
                      <td>
                        <input
                          type="text"
                          v-model="item.reason"
                          class="form-control only-border-bottom"
                          :class="{
                            'is-invalid': errors.has(
                              'details.' + index + '.reason'
                            )
                          }"
                        />
                        <div
                          class="invalid-feedback"
                          v-if="errors.has('details.' + index + '.reason')"
                        >
                          {{ errors.first('details.' + index + '.reason') }}
                        </div>
                      </td>
                      <td class="text-center">
                        <a
                          href="#"
                          class="text-danger"
                          @click.prevent="removeRow(item)"
                        >
                          <i class="fa fa-trash"></i>
                        </a>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div class="row mt-3">
            <div class="col-md-12 text-right">
              <ts-button
                class="btn-primary mr-2"
                @click.prevent="update"
                :waiting="saving"
                v-if="model.details.length"
              >
                {{ $t('update') }}
              </ts-button>
              <ts-button
                class="btn-default"
                @click="$router.push({ name: 'stock-count-entry' })"
              >
                {{ $t('cancel') }}
              </ts-button>
            </div>
          </div>
        </form>
      </ts-card-wrapper>
    </ts-card>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { Errors } from 'form-backend-validation'
import moment from 'moment'

export default {
  name: 'stock-count-entry-edit',
  data() {
    return {
      model: {
        stock_count_id: 0,
        note: '',
        count_date: moment().format('DD-MM-YYYY'),
        details: []
      },
      newRow: {
        stock_count_detail_id: 0,
        barcode: '',
        product_id: '',
        system_qty: '',
        count_qty: '',
        different_qty: '',
        reason: ''
      },
      errors: new Errors(),
      ready_fetch: false,
      saving: false
    }
  },
  computed: {
    ...mapState('stockCountEntry', ['products', 'edit_data']),
    ...mapGetters('stockCountEntry', ['productNotIncludeSelected'])
  },
  created() {
    this.fetchResourceBeforeCreate()
  },
  methods: {
    fetchResourceBeforeCreate() {
      this.ready_fetch = true
      this.$store
        .dispatch('stockCountEntry/dataBeforeCreate')
        .then(response => {
          this.ready_fetch = false
          this.setEditData()
        })
        .catch(error => {
          this.ready_fetch = false
          this.$toasted.error(error.message)
        })
    },
    addNewRow() {
      this.model.details.push(_.clone(this.newRow))
    },
    removeRow(item) {
      this.model.details.splice(this.model.details.indexOf(item), 1)
    },

    filterProductFunction(search, options) {
      return options.filter(option => {
        option = typeof option === 'object' ? option.text : option

        return option.toLowerCase().includes(search.toLowerCase())
      })
    },
    barcodeChange(item) {
      if (!item.barcode) {
        item.product_id = ''
        item.system_qty = 0
        return
      }
      let result = this.products.filter(p => p.barcode == item.barcode)
      item.product_id = result[0].product_id
      this.getSystemQty(item)
    },
    productChange(item) {
      if (!item.product_id) {
        item.barcode = ''
        item.system_qty = 0
        return
      } else {
        let result = this.products.filter(p => p.product_id == item.product_id)
        item.barcode = result[0].barcode
        this.getSystemQty(item)
      }
    },
    update() {
      this.errors = new Errors()
      this.saving = true
      this.$store
        .dispatch('stockCountEntry/update', this.model)
        .then(response => {
          this.$toasted.success(response.message)
          this.$router.push({ name: 'stock-count-entry' })
        })
        .catch(error => {
          this.saving = false
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
    },
    getSystemQty(row) {
      this.$store
        .dispatch('stockCountEntry/getSystemQty', row.product_id)
        .then(response => {
          row.system_qty = row.count_qty = parseFloat(response.balance)
        })
        .catch(error => {
          this.$toasted.info(error.message)
        })
    },
    clearInput() {
      this.model = {
        note: '',
        count_date: moment().format('DD-MM-YYYY'),
        details: []
      }
    },
    setEditData() {
      this.model = {
        stock_count_id: this.edit_data.stock_count_id,
        note: this.edit_data.note,
        count_date: this.edit_data.count_date,
        details: []
      }
      this.edit_data.details.map(el => {
        this.model.details.push(el)
      })
    }
  },
  watch: {
    'model.details': {
      handler() {
        this.model.details.map(el => {
          el.different_qty = el.count_qty - el.system_qty
        })
      },
      deep: true
    }
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('stockCountEntry/RESET_STATE')
    this.$store.commit('stockCountEntry/SET_EDIT_DATA', {})
    next()
  }
}
</script>
<style lang="css" scoped>
#container-table {
	max-height: 50vh;
	overflow-y:scroll;
	overflow-x: hidden;
	scrollbar-width: none;
   -ms-overflow-style: none;
}
::-webkit-scrollbar {
		width: 3px;  /* Remove scrollbar space */
		background: transparent;  /* Optional: just make scrollbar invisible */
}
/* Optional: show position indicator in red */
::-webkit-scrollbar-thumb {
		background: rgb(194, 194, 194);
}
	table td {
		vertical-align : middle;
	}
	.only-border-bottom {
		border-top: none;
		border-left: none;
		border-right: none;
		outline: none;
	}
	.table > thead > tr > th {
	  position: sticky;
		position: -webkit-sticky;
		top: 0;
		z-index: 2;
	}
	.table > tbody > tr > td{
		padding-top: 5px !important;
		padding-bottom: 5px !important;
		border: none !important
	}
	#amountValue tr > td{
		padding: 5px;
	}
</style>
